import React, { useState, useEffect } from "react";
import { showConfirm, showSuccess, showError } from "component/utils/SweetAlert";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import axios from "axios";

export default function UploadAbsensi({ user, onBack }) {
  const [formData, setFormData] = useState({
    file: null,
    entry_by: user?.name || "",
    reg_desc: user?.company || "",
  });

  
  const handleChangeFile = (e) => {
    setFormData({
      ...formData,
      file: e.target.files[0],
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = new FormData();
    data.append("file", formData.file);
    data.append("entry_by", formData.entry_by);
    data.append("reg_desc", formData.reg_desc);

    try {
      const res = await fetch("/api/upload-absensi", {
        method: "POST",
        body: data,
      });
      const result = await res.json();
      console.log(result);
      alert("Upload berhasil!");
    } catch (err) {
      console.error(err);
      alert("Upload gagal!");
    }
  };

  return (
    <form className="p-3" onSubmit={handleSubmit}>
      <div className="row">
        <div className="col-md-6 mb-3">
          <label className="form-label">Upload File (CSV/Excel):</label>
          <input type="file" className="form-control" id="file" name="file" accept=".csv" onChange={handleChangeFile} required/>
        </div>
        <div className="col-md-6 mb-3">
          <button type="submit" className="btn btn-primary">
            Upload
          </button>
          <button type="button" class="btn btn-secondary m-2" onClick={onBack}>
            Back
          </button>
        </div>
      </div>
    </form>
  );
}
